export default __webpack_public_path__ + "static/media/25-disappointed-but-relieved-face_1f625.85a7a370.png";